import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=14904fd6&scoped=true"
import script from "./ReportDetail.vue?vue&type=script&lang=js"
export * from "./ReportDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportDetail.vue?vue&type=style&index=0&id=14904fd6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14904fd6",
  null
  
)

export default component.exports